import * as React from 'react';
import { t } from '@reos/i18n';
import { formatMoney } from '../lib/properties.js';
import type { PriceExpectationPrompt } from '../lib/owner-price-expectation.js';

/**
 * Krok PROP3B bod 1/2 — VYZVA U POLE „CENA" (jedna na obou obrazovkach).
 *
 * Koncept inzeratu i nova faktura za provizi se ptaji TOTOZNE („Nabídková
 * cena chybí. Použít představu majitele 6 900 000 Kč?" · [Použít jako
 * nabídkovou] · [Zadat jinou]), takze tu vetu i tlacitka kresli jeden
 * komponent — dve kopie teze pravdy by se rozesly (CLAUDE.md §8.2).
 *
 * Rozhodnuti, KDY se vyzva ukaze, dela `priceExpectationPrompt`
 * (`lib/owner-price-expectation.ts`).
 */

const cs = { locale: 'cs' } as const;

export function PriceExpectationNote({
  prompt,
  onUse,
  onEnterOther,
  /** Text pro stav „ani predstava neni"; `null` = na teto obrazovce se nehlasi. */
  missingText = null,
  testIdPrefix = 'price-expectation',
}: {
  readonly prompt: PriceExpectationPrompt | null;
  readonly onUse: () => void;
  readonly onEnterOther: () => void;
  readonly missingText?: string | null;
  readonly testIdPrefix?: string;
}): React.JSX.Element | null {
  if (prompt === null) return null;
  if (prompt.kind === 'missing') {
    if (missingText === null) return null;
    return (
      <p className="text-xs" style={{ color: 'var(--rh-text-muted)' }} data-testid={`${testIdPrefix}-missing`}>
        {missingText}
      </p>
    );
  }
  const price = formatMoney(prompt.expectation) ?? '';
  return (
    <div className="text-xs flex flex-col gap-1" data-testid={`${testIdPrefix}-prompt`}>
      <span>{t('webAdmin.priceExpectation.prompt', { ...cs, values: { price } })}</span>
      <span className="flex gap-2">
        <button type="button" className="rh-v4-btn rh-v4-btn--chip" onClick={onUse} data-testid={`${testIdPrefix}-use`}>
          {t('webAdmin.priceExpectation.use', cs)}
        </button>
        <button
          type="button"
          className="rh-v4-btn rh-v4-btn--plain"
          onClick={onEnterOther}
          data-testid={`${testIdPrefix}-other`}
        >
          {t('webAdmin.priceExpectation.other', cs)}
        </button>
      </span>
    </div>
  );
}
